const PAID_MEDIA = new Set([
  'cpc',
  'ppc',
  'paid',
  'paid_search',
  'paid_social',
  'display',
]);

const META_SOURCES = new Set(['facebook', 'fb', 'instagram', 'ig', 'meta']);
const GOOGLE_SOURCES = new Set(['google', 'googleads', 'adwords', 'youtube']);
const GOOGLE_CLICK_KEYS = ['gclid', 'gbraid', 'wbraid'];
const META_CLICK_KEYS = ['fbclid', 'fbc', 'fbp'];

const compactIdentifier = (value, { maskIdentifiers = true } = {}) => {
  if (!value) return null;
  if (!maskIdentifiers || value.length <= 14) return value;
  return `${value.slice(0, 7)}…${value.slice(-4)}`;
};

const entryPage = url => url.pathname;
const pageUrl = url =>
  ['https:', 'http:'].includes(url.protocol)
    ? `${url.origin}${url.pathname}`
    : null;

const buildReferralSummary = (referral, options) => {
  if (!referral || (referral.source_type !== 'ad' && !referral.ctwa_clid)) {
    return null;
  }

  const identifier = referral.ctwa_clid || referral.source_id || null;
  let sourceUrl = null;
  try {
    sourceUrl = referral.source_url ? new URL(referral.source_url) : null;
  } catch {
    sourceUrl = null;
  }

  return {
    provider: 'meta',
    campaign: referral.headline || referral.title || referral.source_id || null,
    evidence: referral.ctwa_clid ? 'complete' : 'partial',
    identifierType: referral.ctwa_clid ? 'ctwa_clid' : 'source_id',
    identifier: compactIdentifier(identifier, options),
    entryPage: sourceUrl ? entryPage(sourceUrl) : null,
    pageUrl: sourceUrl ? pageUrl(sourceUrl) : null,
    source: 'whatsappReferral',
  };
};

const buildRefererSummary = (referer, options) => {
  if (!referer) return null;

  let url;
  try {
    url = new URL(referer);
  } catch {
    return null;
  }

  const params = url.searchParams;
  const clickIdentifier = [...GOOGLE_CLICK_KEYS, ...META_CLICK_KEYS].find(key =>
    params.has(key)
  );
  const utmSource = params.get('utm_source')?.toLowerCase() || '';
  const utmMedium = params.get('utm_medium')?.toLowerCase() || '';
  const isPaidUtm = PAID_MEDIA.has(utmMedium);

  if (!GOOGLE_CLICK_KEYS.includes(clickIdentifier) && !isPaidUtm) return null;

  let provider = 'paid';
  if (
    GOOGLE_CLICK_KEYS.includes(clickIdentifier) ||
    GOOGLE_SOURCES.has(utmSource)
  ) {
    provider = 'google';
  } else if (
    META_CLICK_KEYS.includes(clickIdentifier) ||
    META_SOURCES.has(utmSource)
  ) {
    provider = 'meta';
  }

  return {
    provider,
    campaign: params.get('utm_campaign'),
    evidence: clickIdentifier ? 'complete' : 'partial',
    identifierType: clickIdentifier || 'utm',
    identifier: compactIdentifier(
      clickIdentifier ? params.get(clickIdentifier) : utmMedium,
      options
    ),
    entryPage: entryPage(url),
    pageUrl: pageUrl(url),
    source: 'webWidget',
  };
};

export const buildPaidTrackingSummary = (
  additionalAttributes,
  { maskIdentifiers = true } = {}
) => {
  const attributes = additionalAttributes || {};
  const options = { maskIdentifiers };
  return (
    buildReferralSummary(attributes.referral, options) ||
    buildRefererSummary(attributes.referer, options)
  );
};
